import { render, staticRenderFns } from "./sharefilerightclick.vue?vue&type=template&id=336ab3f6&"
import script from "./sharefilerightclick.vue?vue&type=script&lang=js&"
export * from "./sharefilerightclick.vue?vue&type=script&lang=js&"
import style0 from "./sharefilerightclick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports